const publishSteps = [
  {
    element: '[data-tour="publish-toggle"]',
    popover: {
      title: "Offer or Request",
      description: "Switch between offering a ride (you're driving) and requesting one (you need a seat).",
    },
  },
  {
    element: '[data-tour="publish-route"]',
    popover: {
      title: "Set Your Route",
      description: "Pick your departure and arrival cities, and optionally add a via route like a highway or stop.",
    },
  },
  {
    element: '[data-tour="publish-datetime"]',
    popover: {
      title: "Departure Date & Time",
      description: "Set when you plan to leave. Other users will see this on the feed.",
    },
  },
  {
    element: '[data-tour="publish-pricing"]',
    popover: {
      title: "Pricing & Seats",
      description: "Set your fare per seat and how many seats are available. Only visible when offering a ride.",
    },
  },
  {
    element: '[data-tour="publish-vehicle"]',
    popover: {
      title: "Vehicle Details",
      description: "Optionally add your vehicle model so passengers know what to expect.",
    },
  },
  {
    element: '[data-tour="publish-submit"]',
    popover: {
      title: "Publish",
      description: "All set! Hit this button to post your ride or request. It will appear on the feed immediately.",
    },
  },
];

export default publishSteps;
